<template>
    <div class="product-categories">
        <section class="product classic-practik" v-if="$route.params.product === this.$parent.products.classic_practik.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.classic_practik.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.classic_practik.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.classic_practik.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.classic_practik.avantaje_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.classic_practik.avantaje_descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.classic_practik.accesorii_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.classic_practik.accesorii_descriere"></div>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.classic_practik.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.classic_practik.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.classic_practik.info_technice.img.src" :alt="this.$parent.products.classic_practik.info_technice.img.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.classic_practik.info_technice.specificatii"></div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.classic_practik.garantie.titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.classic_practik.garantie.descriere"></div>
                <img :src="this.$parent.products.classic_practik.garantie.imgSrc" :alt="this.$parent.products.classic_practik.garantie.titlu" class="image-guarantee">
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC PRACTIK -->

        <section class="product classic-mat" v-if="$route.params.product === this.$parent.products.classic_mat.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.classic_mat.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.classic_mat.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.classic_mat.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.classic_mat.culori_classic_mat_titlu }}</h3>
                <ul class="product-colors product-colors__mat">
                    <li v-for="color in this.$parent.products.classic_mat.culori_classic_mat" :key="color.id">
                        <div class="content">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.classic_mat.culori_classic_high_coat_titlu }}</h3>
                <ul class="product-colors product-colors__high-coat">
                    <li v-for="color in this.$parent.products.classic_mat.culori_classic_high_coat" :key="color.id">
                        <div class="content">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.classic_mat.avantaje_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.classic_mat.avantaje_descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.classic_mat.accesorii_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.classic_mat.accesorii_descriere"></div>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.classic_mat.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.classic_mat.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.classic_mat.info_technice.img_1.src" :alt="this.$parent.products.classic_mat.info_technice.img_1.alt">
                        <img :src="this.$parent.products.classic_mat.info_technice.img_2.src" :alt="this.$parent.products.classic_mat.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.classic_mat.info_technice.specificatii"></div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.classic_mat.garantie.titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.classic_mat.garantie.descriere"></div>
                <img :src="this.$parent.products.classic_mat.garantie.imgSrc" :alt="this.$parent.products.classic_mat.garantie.titlu" class="image-guarantee">
                <h3 class="product-title">{{ this.$parent.products.classic_mat.pliant_titlu }}</h3>
               <div class="product-links">
                   <a :href="this.$parent.products.classic_mat.pliant.href" :title="this.$parent.products.classic_mat.pliant.titlu" target="_blank">
                       {{ this.$parent.products.classic_mat.pliant.titlu }}
                       <img :src="this.$parent.products.classic_mat.pliant.src" :alt="this.$parent.products.classic_mat.pliant.titlu">
                   </a>
                   <a :href="this.$parent.products.classic_mat.pliant_instalare.href" :title="this.$parent.products.classic_mat.pliant_instalare.titlu" target="_blank">
                       {{ this.$parent.products.classic_mat.pliant_instalare.titlu }}
                       <img :src="this.$parent.products.classic_mat.pliant_instalare.src" :alt="this.$parent.products.classic_mat.pliant_instalare.titlu">
                   </a>
               </div>
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC MATT -->

        <section class="product classic-avangarde" v-if="$route.params.product === this.$parent.products.classic_avangarde.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.classic_avangarde.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.classic_avangarde.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.classic_avangarde.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.classic_avangarde.culori_classic_avangarde_titlu }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.classic_avangarde.culori_classic_avangarde" :key="color.id">
                        <div class="content">
                            <img :src="color.imgSrc" :alt="color.nume">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.classic_avangarde.avantaje_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.classic_avangarde.avantaje_descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.classic_avangarde.accesorii_titlu }}</h3>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.classic_avangarde.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.classic_avangarde.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.classic_avangarde.info_technice.img_1.src" :alt="this.$parent.products.classic_avangarde.info_technice.img_1.alt">
                        <img :src="this.$parent.products.classic_avangarde.info_technice.img_2.src" :alt="this.$parent.products.classic_avangarde.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.classic_avangarde.info_technice.specificatii"></div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.classic_avangarde.garantie.titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.classic_avangarde.garantie.descriere"></div>
                <img :src="this.$parent.products.classic_avangarde.garantie.imgSrc" :alt="this.$parent.products.classic_avangarde.garantie.titlu" class="image-guarantee">
                <h3 class="product-title">{{ this.$parent.products.classic_avangarde.pliant_titlu }}</h3>
               <div class="product-links">
                   <a :href="this.$parent.products.classic_avangarde.pliant.href" :title="this.$parent.products.classic_avangarde.pliant.titlu" target="_blank">
                       {{ this.$parent.products.classic_avangarde.pliant.titlu }}
                       <img :src="this.$parent.products.classic_avangarde.pliant.src" :alt="this.$parent.products.classic_avangarde.pliant.titlu">
                   </a>
                   <a :href="this.$parent.products.classic_avangarde.pliant_instalare.href" :title="this.$parent.products.classic_avangarde.pliant_instalare.titlu" target="_blank">
                       {{ this.$parent.products.classic_avangarde.pliant_instalare.titlu }}
                       <img :src="this.$parent.products.classic_avangarde.pliant_instalare.src" :alt="this.$parent.products.classic_avangarde.pliant_instalare.titlu">
                   </a>
               </div>
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC AVANGARDE -->

        <section class="product slate" v-if="$route.params.product === this.$parent.products.slate.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.slate.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.slate.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.slate.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.slate.culori_slate_mat_titlu }}</h3>
                <ul class="product-colors product-colors__mat">
                    <li v-for="color in this.$parent.products.slate.culori_slate_mat" :key="color.id">
                        <div class="content">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.slate.culori_slate_high_coat_titlu }}</h3>
                <ul class="product-colors product-colors__high-coat">
                    <li v-for="color in this.$parent.products.slate.culori_slate_high_coat" :key="color.id">
                        <div class="content">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.slate.avantaje_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.slate.avantaje_descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.slate.accesorii_titlu }}</h3>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.slate.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.slate.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.slate.info_technice.img.src" :alt="this.$parent.products.slate.info_technice.img.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.slate.info_technice.specificatii"></div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.slate.garantie.titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.slate.garantie.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.slate.pliant_titlu }}</h3>
                <div class="product-links">
                   <a :href="this.$parent.products.slate.pliant.href" :title="this.$parent.products.slate.pliant.titlu" target="_blank">
                       {{ this.$parent.products.slate.pliant.titlu }}
                       <img :src="this.$parent.products.slate.pliant.src" :alt="this.$parent.products.slate.pliant.titlu">
                   </a>
                   <a :href="this.$parent.products.slate.pliant_instalare.href" :title="this.$parent.products.slate.pliant_instalare.titlu" target="_blank">
                       {{ this.$parent.products.slate.pliant_instalare.titlu }}
                       <img :src="this.$parent.products.slate.pliant_instalare.src" :alt="this.$parent.products.slate.pliant_instalare.titlu">
                   </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL SLATE -->

        <section class="product wood" v-if="$route.params.product === this.$parent.products.wood.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.wood.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.wood.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.wood.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.wood.culori_wood_titlu }}</h3>
                <ul class="product-colors product-colors__mat">
                    <li v-for="color in this.$parent.products.wood.culori_wood" :key="color.id">
                        <div class="content">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.wood.avantaje_titlu }}</h3>
                <div class="product-benefits" v-html="this.$parent.products.wood.avantaje_descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.wood.accesorii_titlu }}</h3>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.wood.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.wood.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.wood.info_technice.img.src" :alt="this.$parent.products.wood.info_technice.img.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.wood.info_technice.specificatii"></div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.wood.garantie.titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.wood.garantie.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.wood.pliant_titlu }}</h3>
                <div class="product-links">
                   <a :href="this.$parent.products.wood.pliant.href" :title="this.$parent.products.wood.pliant.titlu" target="_blank">
                       {{ this.$parent.products.wood.pliant.titlu }}
                       <img :src="this.$parent.products.wood.pliant.src" :alt="this.$parent.products.wood.pliant.titlu">
                   </a>
                   <a :href="this.$parent.products.wood.pliant_instalare.href" :title="this.$parent.products.wood.pliant_instalare.titlu" target="_blank">
                       {{ this.$parent.products.wood.pliant_instalare.titlu }}
                       <img :src="this.$parent.products.wood.pliant_instalare.src" :alt="this.$parent.products.wood.pliant_instalare.titlu">
                   </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL WOOD -->

        <section class="product tabla-prefaltuita" v-if="$route.params.product === this.$parent.products.tabla_prefaltuita.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.tabla_prefaltuita.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.tabla_prefaltuita.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.tabla_prefaltuita.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.tabla_prefaltuita.culori_tabla_titlu }}</h3>
                <ul class="product-colors product-colors__mat">
                    <li v-for="color in this.$parent.products.tabla_prefaltuita.culori_tabla" :key="color.id">
                        <div class="content">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.tabla_prefaltuita.avantaje_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.tabla_prefaltuita.avantaje_descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.tabla_prefaltuita.accesorii_titlu }}</h3>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.tabla_prefaltuita.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.tabla_prefaltuita.info_technice_click.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.tabla_prefaltuita.info_technice_click.img.src" :alt="this.$parent.products.tabla_prefaltuita.info_technice_click.img.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.tabla_prefaltuita.info_technice_click.specificatii"></div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.tabla_prefaltuita.info_technice_click_s.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.tabla_prefaltuita.info_technice_click_s.img.src" :alt="this.$parent.products.tabla_prefaltuita.info_technice_click_s.img.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.tabla_prefaltuita.info_technice_click_s.specificatii"></div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.tabla_prefaltuita.garantie.titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.tabla_prefaltuita.garantie.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.tabla_prefaltuita.pliant_titlu }}</h3>
                <div class="product-links">
                   <a :href="this.$parent.products.tabla_prefaltuita.pliant.href" :title="this.$parent.products.tabla_prefaltuita.pliant.titlu" target="_blank">
                       {{ this.$parent.products.tabla_prefaltuita.pliant.titlu }}
                       <img :src="this.$parent.products.tabla_prefaltuita.pliant.src" :alt="this.$parent.products.tabla_prefaltuita.pliant.titlu">
                   </a>
                   <a :href="this.$parent.products.tabla_prefaltuita.pliant_instalare.href" :title="this.$parent.products.tabla_prefaltuita.pliant_instalare.titlu" target="_blank">
                       {{ this.$parent.products.tabla_prefaltuita.pliant_instalare.titlu }}
                       <img :src="this.$parent.products.tabla_prefaltuita.pliant_instalare.src" :alt="this.$parent.products.tabla_prefaltuita.pliant_instalare.titlu">
                   </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL TABLA PREFALTUITA -->

        <section class="product ronda" v-if="$route.params.product === this.$parent.products.ronda.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.ronda.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.ronda.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.ronda.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.ronda.culori_ronda_titlu }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.ronda.culori_ronda" :key="color.id">
                        <div class="content">
                            <img :src="color.imgSrc" :alt="color.nume">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.ronda.culori_ronda_otel_prevopsit_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.ronda.culori_ronda_otel_prevopsit_descriere"></div>
                <ul class="product-colors product-colors__ronda-steel">
                    <li v-for="color in this.$parent.products.ronda.culori_ronda_otel_prevopsit" :key="color.id">
                        <div class="content">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.ronda.avantaje_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.ronda.avantaje_descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.ronda.accesorii_titlu }}</h3>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.ronda.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.ronda.garantie.titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.ronda.garantie.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.ronda.pliant_titlu }}</h3>
                <div class="product-links">
                   <a :href="this.$parent.products.ronda.pliant.href" :title="this.$parent.products.ronda.pliant.titlu" target="_blank">
                       {{ this.$parent.products.ronda.pliant.titlu }}
                       <img :src="this.$parent.products.ronda.pliant.src" :alt="this.$parent.products.ronda.pliant.titlu">
                   </a>
                   <a :href="this.$parent.products.ronda.pliant_instalare.href" :title="this.$parent.products.ronda.pliant_instalare.titlu" target="_blank">
                       {{ this.$parent.products.ronda.pliant_instalare.titlu }}
                       <img :src="this.$parent.products.ronda.pliant_instalare.src" :alt="this.$parent.products.ronda.pliant_instalare.titlu">
                   </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL RONDA -->

        <section class="product quadra" v-if="$route.params.product === this.$parent.products.quadra.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.quadra.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.quadra.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.quadra.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.quadra.dimensiuni_quadra_titlu }}</h3>
                <div class="product-description" v-html="this.$parent.products.quadra.dimensiuni_quadra_descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.quadra.culori_quadra_titlu }}</h3>
                <ul class="product-colors product-colors__quadra">
                    <li v-for="color in this.$parent.products.quadra.culori_quadra" :key="color.id">
                        <div class="content">
                            <span class="color">{{ color.nume }}</span>
                            <p>{{ color.text }}</p>
                        </div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.quadra.accesorii_titlu }}</h3>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.quadra.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.quadra.pliant_titlu }}</h3>
                <div class="product-links">
                   <a :href="this.$parent.products.quadra.pliant_instalare.href" :title="this.$parent.products.quadra.pliant_instalare.titlu" target="_blank">
                       {{ this.$parent.products.quadra.pliant_instalare.titlu }}
                       <img :src="this.$parent.products.quadra.pliant_instalare.src" :alt="this.$parent.products.quadra.pliant_instalare.titlu">
                   </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL QUADRA -->

        <section class="product prima" v-if="$route.params.product === this.$parent.products.prima.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.prima.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.prima.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.prima.descriere"></div>
            </div>
        </section>
        <!-- END SECTION PROFIL PRIMA -->

        <section class="product plus" v-if="$route.params.product === this.$parent.products.plus.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.plus.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.plus.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.plus.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.plus.accesorii_titlu }}</h3>
                <ul class="product-accessories row">
                    <li class="col-sm-6" v-for="accessory in this.$parent.products.plus.accesorii" :key="accessory.id">
                        <img :src="accessory.imgSrc" :alt="accessory.nume">
                        <h5>{{ accessory.nume }}</h5>
                    </li>
                </ul>
            </div>
        </section>
        <!-- END SECTION PROFIL PLUS -->

    </div>
    
</template>
<script>
export default {
  data() {
    return {
      name: "novatikProducts",
      options: {
        arrows: true,
        dots: true,
        speed: 750,
        fade: true,
        pauseOnHover: true,
        infinite: true,
        autoplay: true
      }
    };
  }
};
</script>
<style lang="scss">
@import "../../assets/css/_variables.scss";

.page-novatik {
  .product-info__images {
    img {
      margin-bottom: 1rem;
    }
  }
  /* ==========
   ========== GENERAL ==========
                      ========= */
  .product-benefits {
    li {
      border-bottom: 1px solid #f4f4f4;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1rem 1rem 2rem;
      position: relative;
      &:before {
        content: "";
        background-color: #0c9533;
        border-radius: 50%;
        display: block;
        margin-right: 10px;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -5px;
        height: 10px;
        width: 10px;
      }
    }
  }
  .classic-mat,
  .slate,
  .wood,
  .tabla-prefaltuita {
    .product-colors {
      li {
        margin: 0;
        width: 50%;
      }
      .content {
        padding: 1rem;
      }
      span {
        color: $white;
      }
      p {
        color: rgba($white, 0.8);
      }
      &__mat {
        li {
          &:first-child {
            .content {
              background-color: $brick-mat;
            }
          }
          &:nth-child(2) {
            .content {
              background-color: $brown-mat;
            }
          }
          &:nth-child(3) {
            .content {
              background-color: $black-mat;
            }
          }
          &:nth-child(4) {
            .content {
              background-color: $burgundy-mat;
            }
          }
          &:nth-child(5) {
            .content {
              background-color: $grey-mat;
            }
          }
        }
      }
      &__high-coat {
        li {
          &:first-child {
            .content {
              background-color: $black-high-coat;
            }
          }
          &:last-child {
            .content {
              background-color: $grey-high-coat;
            }
          }
        }
      }
    }
  }

  /* ==========
   ========== CLASSIC MATT ==========
                         ========= */
  .classic-mat {
    .product-info {
      &__images {
        img:first-child {
          margin-bottom: 1rem;
        }
      }
    }
    .product-description {
      .structure,
      .guarantee {
        text-align: center;
        img {
          display: inline-block;
        }
      }
    }
  }

  /* ==========
   ========== CLASSIC AVANGARDE ==========
                              ========= */
  .classic-avangarde {
    .product-accessories {
      li:first-child {
        img {
          width: 100%;
        }
      }
    }
  }

  /* ==========
   ========== SLATE ==========
                  ========= */
  .slate {
    .advantages-list {
      li {
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 1rem 1rem 2rem;
        position: relative;
        &:before {
          content: "";
          background-color: #0c9533;
          border-radius: 50%;
          display: block;
          margin-right: 10px;
          position: absolute;
          top: 50%;
          left: 0;
          margin-top: -5px;
          height: 10px;
          width: 10px;
        }
      }
    }
  }

  /* ==========
   ========== TABLA PREFALTUITA ==========
                              ========= */
  .tabla-prefaltuita {
    .product-description {
      .blackboard-grip {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
    }
  }
  /* ==========
   ========== RONDA ==========
                  ========= */
  .ronda {
    .product-description {
      .ronda-description-images {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .normal-gutter {
          margin-right: 1rem;
        }
      }
    }
    .product-colors {
      img {
        border-radius: 0;
      }
      &__ronda-steel {
        .content {
          padding: 1rem;
        }
        span {
          color: $white;
        }
        p {
          color: rgba($white, 0.8);
        }
        li {
          margin: 0;
          width: 50%;
          &:first-child {
            .content {
              background-color: $ronda-white;
              span {
                color: $black;
              }
              p {
                color: rgba($black, 0.8);
              }
            }
          }
          &:nth-child(2) {
            .content {
              background-color: $ronda-red;
            }
          }
          &:nth-child(3) {
            .content {
              background-color: $ronda-brown;
            }
          }
          &:nth-child(4) {
            .content {
              background-color: $ronda-black;
            }
          }
          &:nth-child(5) {
            .content {
              background-color: $ronda-brick;
            }
          }
          &:nth-child(6) {
            .content {
              background-color: $ronda-chocolate;
            }
          }
          &:nth-child(7) {
            .content {
              background-color: $ronda-burgundy;
            }
          }
          &:nth-child(8) {
            .content {
              background-color: $ronda-cherry;
            }
          }
          &:nth-child(9) {
            .content {
              background-color: $ronda-grey;
            }
          }
          &:nth-child(10) {
            .content {
              background-color: $ronda-green;
            }
          }
        }
      }
    }
  }

  /* ==========
   ========== QUADRA ==========
                   ========= */
  .quadra {
    .product-description {
      .dimensions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .dimension {
          margin-right: 2rem;
          &:last-child {
            margin: 0;
          }
        }
      }
    }
    .product-colors {
      img {
        border-radius: 0;
      }
      .content {
        padding: 1rem;
      }
      span {
        color: $white;
      }
      p {
        color: rgba($white, 0.8);
      }
      li {
        margin: 0;
        width: 50%;
        &:first-child {
          .content {
            background-color: $ronda-white;
            span {
              color: $black;
            }
            p {
              color: rgba($black, 0.8);
            }
          }
        }
        &:nth-child(2) {
          .content {
            background-color: $ronda-red;
          }
        }
        &:nth-child(3) {
          .content {
            background-color: $ronda-brown;
          }
        }
        &:nth-child(4) {
          .content {
            background-color: $ronda-black;
          }
        }
        &:nth-child(5) {
          .content {
            background-color: $ronda-brick;
          }
        }
        &:nth-child(6) {
          .content {
            background-color: $ronda-chocolate;
          }
        }
        &:nth-child(7) {
          .content {
            background-color: $ronda-grey;
          }
        }
      }
    }
  }

  /* ==========
   ========== PRIMA ==========
                  ========= */
  .prima {
    .product-description {
      .novatik-prima {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        &__structure {
          margin-right: 2rem;
        }
      }
      .product-benefits {
        padding: 0;
        margin: 0;
        li {
          &:before {
            background: none;
            border-radius: 0;
            color: $secondary-color;
            margin-top: -12px;
            font-weight: $bold;
            height: auto;
            width: 10px;
          }
          &:first-child:before {
            content: "1.";
          }
          &:nth-child(2):before {
            content: "2.";
          }
          &:nth-child(3):before {
            content: "3.";
          }
          &:last-child:before {
            content: "4.";
          }
        }
      }
    }
  }
}

/*=============================================
=            RESPONSIVE            =
=============================================*/
@media (max-width: 767.98px) {
  .page-novatik {
    .product-accessories {
      img {
        width: auto;
      }
    }
    .product-info {
      flex-wrap: wrap;
      &__images {
        margin: 0 auto 1rem auto;
      }
      &__specifications {
        width: 100%;
      }
    }
    .product-colors {
      justify-content: center;
    }
    .image-guarantee {
      width: 100%;
    }

    .classic-mat {
      .product-description {
        img {
          width: 100%;
        }
      }
    }
    .tabla-prefaltuita {
      .product-description {
        .blackboard-grip {
          justify-content: center;
        }
        .novatik-click,
        .novatik-click-s {
          margin-bottom: 1rem;
        }
      }
    }
    .ronda {
      .product-description {
        .ronda-description-images {
          justify-content: center;
        }
      }
    }
    .quadra {
      .product-description {
        .dimensions {
          justify-content: center;
        }
      }
    }
    .prima {
      .product-description {
        .novatik-prima {
          justify-content: center;
          flex-direction: column;
          &__structure {
            margin: 0 0 1rem 0;
          }
        }
      }
    }
  }
}

@media (max-width: 575.98px) {
  .page-novatik {
    .product-accessories {
      img {
        width: auto;
      }
    }
    .product-info__specifications {
      li {
        display: block;
        strong {
          display: block;
          margin: 0;
          width: 100%;
        }
      }
    }
    .classic-mat {
      .product-description {
        .guarantee {
          img {
            width: auto;
          }
        }
      }
    }
    .ronda {
      .product-description {
        .ronda-description-images {
          flex-direction: column;
          .normal-gutter {
            margin: 0 0 1rem 0;
          }
        }
      }
    }
    .quadra {
      .product-description {
        .dimensions {
          flex-direction: column;
          .dimension {
            margin: 0 0 2rem 0;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/novatikProducts.vue